import { GetterTree } from 'vuex';
import { ProfileState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ProfileState, RootState> = {
  fullName(state): string {
    const { user } = state;
    const loginId = (user && user.loginId) || '';
    const loginName = (user && user.loginName) || '';
    return `${loginId} (${loginName})`;
  },
  jwt(state): string {
    const { authorize } = state;
    const jwt = (authorize && authorize.jwt) || '';
    return jwt;
  }
};
